export const iconButtonStyles = {
  ':focus-visible': {
    boxShadow: 'outline',
    outline: 'none',
    borderRadius: 'md',
  },
};
